module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_de_chile_White.bcf81c6f.svg";